import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import ModalTitle from './ModalItem/ModalTitle';
import ModalIllustration from './ModalItem/ModalIllustration';
import ModalDescription from './ModalItem/ModalDescription';
import TodoTask from '../../../../../../../assets/img/Todo-Task.png';
import ModalButton from './ModalItem/ModalButton';

const WorkExpTestModal = ({ visible, onStart, onModalClose }) => {
  return (
    <div>
      <Modal
        visible={visible}
        footer={null}
        width="504px"
        bodyStyle={{
          padding: '24px 32px',
          paddingTop: 14.4.toExponential,
          width: 470,
          margin: 'auto'
        }}
        closable={false}
      >
        <ModalIllustration />
        <ModalTitle />
        <ModalDescription />
        <div className='test-modal-column-wrapper'>
          <div className='image-wrapper'>
            <img src={TodoTask} alt="event" />
          </div>
          <div className='column-description-wrapper'>
            <div className='column-description-title'>Complete Work Experience Survey</div>
            <div className='column-description-text'>
              Multiple-choice survey to understand your work style and role in previous projects. Estimated time: 30 minutes.
            </div>
          </div>
        </div>
        <ModalButton onModalClose={onModalClose} onStart={onStart} />
      </Modal>
    </div>
  );
};

WorkExpTestModal.propTypes = {
  visible: PropTypes.bool,
  onStart: PropTypes.func,
  onModalClose: PropTypes.func
};

export default WorkExpTestModal;
